import React from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { RouteComponentProps } from 'react-router-dom';
import core, { App, Poller } from '@gin-betting/core';
import matchList from 'modules/match-list';

import { SKIP_MATCH_LIST_INITIAL_REQUEST, MatchListType } from 'app-constants';
import { checkSkipPollerConfiguration } from 'utils';

const {
    poller: { withPolling },
} = core;
const {
    actions: { searchMatches },
    selectors: { selectFetchStatus },
    components: { MatchListContainer },
} = matchList;

interface OwnProps extends RouteComponentProps<any> {}

interface MappedProps {
    fetchStatus: App.FetchStatus;
}

type Props = OwnProps &
    MappedProps & {
        poller: Poller.Poller<typeof searchMatches>;
    };

class Live extends React.Component<Props> {
    render() {
        const { fetchStatus, poller } = this.props;

        return (
            <MatchListContainer
                type={MatchListType.LIVE}
                fetchStatus={fetchStatus}
                poller={poller}
            />
        );
    }
}

const mapStateToProps = createStructuredSelector({
    fetchStatus: selectFetchStatus,
});

export default compose(
    connect<MappedProps, null, OwnProps>(mapStateToProps),
    withPolling({
        pollerName: App.PollerName.Live,
        executableAction: searchMatches,
        skipInitialRequest: () =>
            !window.__app.previousLocation &&
            checkSkipPollerConfiguration(
                SKIP_MATCH_LIST_INITIAL_REQUEST[App.Routes.LIVE_LIST]
            ),
    })
)(Live);
